import React, { Component, Fragment } from 'react'
import { Form, List, Checkbox, Select, Carousel } from 'antd'
import Pagination from 'components/Pagination/Pagination'
import _ from 'lodash'
import moment from 'moment'
import qs from 'query-string'
import classnames from 'classnames'
import $ from 'jquery'
import { __ } from '@wordpress/i18n'

import './styles.module.scss'
import AppHelper from 'libs/AppHelper'
import { API_HOST } from '../../configs/env'
import whttp from '../../libs/whttp'
import { genFormItemAtrribute } from 'libs/FormHelper'

const Locale = _.get(window, 'VC_CONFIG.Locale')
const PLUGIN_ASSETS_URL = _.get(window, 'VC_CONFIG.PLUGIN_ASSETS_URL')
const defaultListInfo = {
  current: 1, //目前頁數
  page_size: 10, //一頁幾筆
  total: 1, //以此query條件，總共幾筆資料
  rows: [],
}

const NewsMode = {
  Banner: 1, // 首頁大版位Banner 前5則
  Carousel: 2, // 首頁中版位Banner 前5則
  List: 3, // 首頁圖文清單  前5則
  TextOnlyList: 4, // 首頁文字清單 前5則 （最新消息、重要公告）
  Table: 5, // 文字清單包含分頁
  Grid: 6, // 圖文清單
  ByQuery: 7, // 依據URL Query決定
  Grid2: 8, // 購物中心圖文清單，會依照個數變換顯示
  News: 9, // 最新消息/news內頁
}

function isMobileDevice() {
  var mobileDevices = ['Android', 'iPhone', 'iPad']
  var isMobileDevice = 1
  for (var i = 0; i < mobileDevices.length; i++) {
    if (navigator.userAgent.match(mobileDevices[i])) {
      isMobileDevice = 0
    }
  }
  return isMobileDevice
}

let newsSwiper
let init = false
// 前端頁面
export default class NewsListPreview extends Component {
  state = {
    mode: '',
    cname: '',
  }
  componentDidMount() {
    AppHelper.updateConfig()

    this.loadData()

    /* On Resize
     **************************************************************/
    window.addEventListener('resize', () => {
      this.reloadSwiper2()
    })
    this.fetchmode()
    this.GTM()
  }
  GTM = () => {
    var dataLayer = window.dataLayer || []
    $(document)
      .off('click', '#Banner-M div a')
      .on('click', '#Banner-M div a', function() {
        var $text = $(this).attr('alt')
        dataLayer.push({
          event: 'Banner-M_click',
          item: $text,
        })
      })
    $(document)
      .off('click', '#List ul li a')
      .on('click', '#List ul li a', function() {
        var $text = $(this).attr('alt')
        dataLayer.push({
          event: 'news_click',
          item: $text,
        })
      })
    $(document)
      .off('click', '#TextOnlyList ul li a')
      .on('click', '#TextOnlyList ul li a', function() {
        var $text = $(this).attr('alt')
        dataLayer.push({
          event: 'news_click',
          item: $text,
        })
      })
    $(document).on('click', '#Banner div iframe', function() {
      var $text = $(this).attr('alt')
      dataLayer.push({
        event: 'Banner_youtube_click',
        item: $text,
      })
    })
  }
  loadData = (opt) => {
    const query = AppHelper.getURLQuery()
    console.log('qq', query)
    const mode = _.get(this, 'props.mode')
    console.log('loaddata-mode', mode)
    const category_ids =
      mode !== NewsMode.ByQuery || mode !== NewsMode.News
        ? _.get(this, 'props.category_ids')
        : undefined
    let category_name =
      mode === NewsMode.ByQuery || mode === NewsMode.News
        ? _.get(query, 'cname', '注目活動')
        : undefined 
    // 如果 category_name 以 'uniopen' 開頭，去除 'uniopen' 字樣
    if (typeof category_name === 'string' && category_name.startsWith('uniopen')) {
      category_name = category_name.replace(/^uniopen/, '');
    }
    const previewid =
      mode === NewsMode.ByQuery || mode === NewsMode.News
        ? _.get(query, 'previewid', '')
        : undefined
    this.setState({ isFetchData: true })
    var size = 'all'
    if (mode == 9) {
      size = 10
    }
    const queryString = qs.stringify(
      {
        page: _.get(opt, 'page', 1),
        page_size: _.get(opt, 'pageSize', size),
        'category_ids[]': category_ids,
        category_name,
        previewid,
      },
      { skipNull: true }
    )
    console.log('loaddata-queryString', queryString)
    whttp.sharedGet(
      API_HOST + `/api/v1/news?` + queryString,
      null,
      (state, res) => {
        this.setState({ isFetchData: false })
        const { code = 100, reason = '發生錯誤', data = {} } = res
        console.log('loaddata-qqqqq', queryString)
        console.log(code, reason, data, res)
        console.log('loaddata', data)
        if (state === false || code !== 200) {
          console.error(reason)
          return
        }

        this.setState(
          {
            listInfo: data,
            categories: _.get(data, 'categories'),
          },
          () => {
            const options = _.get(this, 'props.app.options', {})
            let mode = _.get(this, 'props.mode', NewsMode.Carousel)

            if (mode === NewsMode.Grid2) {
              this.reloadSwiper2()
            } else {
              this.reloadSwiper()
            }
          }
        )
      }
    )
  }
  reloadSwiper = _.debounce(() => {
    const Swiper = window.Swiper
    if (!Swiper) return
    var swiperKV = new Swiper('.KV-swiper', {
      autoplay: true,
      loop: true,
      speed: 800,
      navigation: {
        nextEl: '.KV-swiper-button-next',
        prevEl: '.KV-swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    })

    var swiperAD = new Swiper('.AD-banner-swiper', {
      autoplay: true,
      loop: true,
      speed: 800,
      pagination: {
        el: '.AD-banner-swiper-pagination',
        clickable: true,
      },
    })
  }, 500)

  // forMobile 首頁、Shopping mall活動快訊
  reloadSwiper2 = _.debounce(() => {
    const Swiper = window.Swiper
    console.log('reloadSwiper2')
    if (!Swiper) return

    let mobile = window.matchMedia('(min-width: 0px) and (max-width: 767px)')
    let tablet = window.matchMedia('(min-width: 767px) and (max-width: 1024px)')
    let desktop = window.matchMedia('(min-width: 1025px)')

    // Enable (for mobile)
    if (mobile.matches) {
      if (!init) {
        init = true
        console.log('kkkkk1')
        setTimeout(() => {
          console.log('kkkkk2')
          newsSwiper = new Swiper('.event-card-scroll_mobile', {
            spaceBetween: 10,
            loop: true,
            slidesPerView: 'auto',
            // init: false,
            pagination: {
              el: '.swiper-pagination',
              dynamicBullets: true,
            },
            breakpoints: {
              767: {
                spaceBetween: 0,
              },
            },
          })
          console.log('kkkkk3', newsSwiper)
        }, 1000)
      }
    }
    // Disable (for tablet)
    else if (tablet.matches) {
      newsSwiper && _.isFunction(newsSwiper.destroy) && newsSwiper.destroy()
      init = false
    }
    // Disable (for desktop)
    else if (desktop.matches) {
      newsSwiper && _.isFunction(newsSwiper.destroy) && newsSwiper.destroy()
      init = false
    }
  }, 500)
  getNewsLink = (newsInfo) => {
    const action_type = _.get(newsInfo, 'action_type')
    const post_id = _.get(newsInfo, 'post_id')
    let INDEX_URL = _.get(window, 'VC_CONFIG.INDEX_URL')
    if (action_type == 1) {
      if (Locale == 'en_US') return `${INDEX_URL}/en-post?postid=${post_id}`
      else return `${INDEX_URL}?p=${post_id}`
    }

    if (action_type == 2) {
      const link = _.get(newsInfo, 'link')
      console.log('getNewsLink', link, newsInfo)
      if (!_.isEmpty(link)) return link
      // return `${VC_CONFIG.INDEX_URL}/news-info/?id=${newsInfo.id}`
    }
    return '#'
  }
  getMode = () => {
    return _.get(this, 'props.mode', NewsMode.Carousel)
  }
  fetchmode = () => {
    var getUrlString = window.location.href
    var url = new URL(getUrlString)
    this.setState({
      mode: url.searchParams.get('mode'),
      cname: url.searchParams.get('cname'),
    })
  }
  render() {
    const options = _.get(this, 'props.app.options', {})
    let mode = _.get(this, 'props.mode', NewsMode.Carousel)
    let category_ids = _.get(this, 'props.category_ids')
    console.log('AppHelper.getURLQuery()', AppHelper.getURLQuery())
    if (mode === NewsMode.ByQuery) {
      const query = AppHelper.getURLQuery()
      mode = parseInt(_.get(query, 'mode', NewsMode.Grid), 10)
      console.log('mode', mode)
    }

    const listInfo = _.get(this, 'state.listInfo')
    const list = _.get(listInfo, 'rows', []).filter(
      (item) => category_ids.indexOf(item.category_id) !== -1
    )
    const news_categories = _.get(options, 'news_categories', []).filter(
      (item) => category_ids.indexOf(item.id) !== -1
    )

    let selectedCategoryId = _.get(
      this,
      'state.selectedCategoryId',
      _.get(news_categories, '0.id')
    )

    let selectedCategoryName = _.get(
      this,
      'state.selectedCategoryName',
      _.get(news_categories, '0.name')
    )
    var isMobile = isMobileDevice()
    var news_url = _.get(window, 'VC_CONFIG.INDEX_URL') + '/news'
    if (Locale == 'en_US')
      news_url = _.get(window, 'VC_CONFIG.INDEX_URL') + '/news-en'

    if (mode === NewsMode.Banner) {
      return (
        <Fragment>
          {/* <div class="jumbotron"> */}
          <div class='KV-banner'>
            {_.map(list, (item, idx) => (
              <div id='Banner'>
                {idx == 0 &&
                  ((item.youtube && (
                    <div
                      class='jumbotron wp-block-cec-vulcan-block-news-list'
                      vu-attributes='{"mode":1,"category_ids":[50]}'>
                      <div class='KV-banner'>
                        <div class='kv-title'>
                          {item.name}
                          <span class='kv-sub-title'>{item.desc}</span>
                        </div>
                        <iframe
                          alt={item.name}
                          id='player'
                          title='player'
                          class='w-100 h-100'
                          src={
                            _.get(item, 'youtube') +
                            '?frameborder=0&modestbranding=1&controls=0&rel=0&autoplay=0&enablejsapi=1'
                          }
                          allow='accelerometer;autohide; encrypted-media; gyroscope; picture-in-picture'
                          allowfullscreen=''
                        />
                      </div>
                    </div>
                  )) ||
                    (!item.youtube && (
                      <div class='KV-banner'>
                        <div class='kv-title'>
                          {item.name}
                          <span class='kv-sub-title'>{item.desc}</span>
                        </div>
                        <img
                          src={_.get(item, 'images.0.url')}
                          alt={item.name}
                        />
                      </div>
                    )))}
              </div>
            ))}
          </div>
          {/* </div> */}
        </Fragment>
      )
    }
    if (mode === NewsMode.Carousel) {
      return (
        <Fragment>
          <div class='swiper-container AD-banner-swiper'>
            <div id='Banner-M' class='swiper-wrapper'>
              {_.map(list, (item, idx) => (
                <div class='swiper-slide'>
                  <a
                    class='banner-item'
                    role='button'
                    alt={`${item.category_name}-${item.name}`}
                    href={this.getNewsLink(item)}
                    onClick={(e) => {
                      if (this.getNewsLink(item) === '#') {
                        e.preventDefault()
                      }
                    }}>
                    <div
                      class='img-2-1'
                      style={{
                        backgroundImage: `url(${_.get(item, 'images.0.url')})`,
                      }}
                    />
                  </a>
                </div>
              ))}
            </div>
          </div>
          <div class='AD-banner-swiper-pagination' />
        </Fragment>
      )
    }
    if (mode === NewsMode.List) {
      return (
        <Fragment>
          <div class='card-header tag-tabs'>
            <nav class='tabs-wrap'>
              <ul class='tabs-content'>
                {_.map(news_categories, (categoryInfo) => (
                  <li
                    className={
                      categoryInfo.id === selectedCategoryId
                        ? 'current_page_item'
                        : null
                    }
                    onClick={() =>
                      this.setState({
                        selectedCategoryId: categoryInfo.id,
                        selectedCategoryName: categoryInfo.name,
                      })
                    }>
                    <a alt={categoryInfo.name} role='button'>
                      {categoryInfo.name}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
            <a
              class='h6 text-decoration-none mb-0'
              role='button'
              href={`${
                window.VC_CONFIG.INDEX_URL
              }/news?mode=6&cname=${selectedCategoryName}`}
              data-toggle='tooltip'
              data-placement='right'
              title='看更多'>
              <i class='icon-plus' />
            </a>
          </div>

          <div id='List' class='card-body pb-0'>
            <ul class='list-unstyled list-item'>
              {_.filter(list, (item) => item.category_id === selectedCategoryId)
                .slice(0, 5)
                .map((item) => (
                  <li>
                    <a
                      alt={`${item.category_name}-${item.name}`}
                      role='button'
                      href={this.getNewsLink(item)}
                      onClick={(e) => {
                        if (this.getNewsLink(item) === '#') {
                          e.preventDefault()
                        }
                      }}>
                      <div class='row align-items-center'>
                        <div class='col-md-5'>
                          <div
                            class='img-2-1 mb-lg-0 mb-3'
                            style={
                              _.get(item, 'images.0.url')
                                ? {
                                    backgroundImage: `url(${_.get(
                                      item,
                                      'images.0.url'
                                    )})`,
                                  }
                                : {
                                    backgroundImage: `url(${
                                      window.VC_CONFIG.PLUGIN_ASSETS_URL
                                    }img/news/logo_empty.jpg)`,
                                  }
                            }
                          />
                        </div>
                        <div class='col-md'>
                          <div class='py-2'>
                            <h5 class='text-navy fw-700 limit-line-1 flex-fill mb-2 h6'>
                              {item.name}
                            </h5>
                            <span class='fw-300 text-body text-justify limit-line-2 mb-2 p'>
                              {item.desc}
                            </span>
                            <span class='text-navy text-nowrap d-block mb-0 note'>
                              {item.start_date} - {item.end_date}
                            </span>
                          </div>
                        </div>
                      </div>
                    </a>
                  </li>
                ))}
              <li>
                <div class='d-flex justify-content-end py-3'>
                  <a
                    class='fw-700 mb-0 text-navy d-inline-flex align-items-center line-hight-fit p'
                    role='button'
                    href={`${
                      window.VC_CONFIG.INDEX_URL
                    }/news?mode=6&cname=${selectedCategoryName}`}>
                    更多活動
                    <i class='text-primary fas fa-chevron-circle-right line-hight-fit mb-0 ml-2' />
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </Fragment>
      )
    }
    if (mode === NewsMode.TextOnlyList) {
      console.log('_.filter(news_categories)', news_categories)
      return (
        <Fragment>
          {_.map(news_categories, (categoryInfo) => (
            <div class='card card-border-primary shadow-0 mb-5'>
              <div class='card-header d-flex justify-content-between align-items-center'>
                {' '}
                <strong class='h6 fw-700 mb-0'>{categoryInfo.name}</strong>
                <a
                  class='h6 text-decoration-none mb-0'
                  role='button'
                  href={`${window.VC_CONFIG.INDEX_URL}/news/?mode=${
                    NewsMode.TextOnlyList
                  }&cname=${categoryInfo.name}`}
                  data-toggle='tooltip'
                  data-placement='right'
                  title='看更多'>
                  <i class='icon-plus' />
                </a>
              </div>
              <div id='TextOnlyList' class='card-body py-0'>
                <ul class='list-unstyled list-item'>
                  {isMobile == 1 &&
                    _.filter(
                      list,
                      (item) => item.category_id === categoryInfo.id
                    )
                      .slice(0, 5)
                      .map((item) => (
                        <li>
                          <a
                            alt={`${item.category_name}-${item.name}`}
                            role='button'
                            href={this.getNewsLink(item)}
                            onClick={(e) => {
                              if (this.getNewsLink(item) === '#') {
                                e.preventDefault()
                              }
                            }}>
                            <div class='d-flex justify-content-between align-items-center text-navy mb-3'>
                              <h5 class='p fw-700 limit-line-1 text-highlight mb-0 mr-2'>
                                {item.name}
                              </h5>
                              <span class='p text-nowrap mb-0 ml-auto'>
                                {item.start_date &&
                                  moment(item.start_date).format('YYYY-MM-DD')}
                              </span>
                            </div>
                            <span class='note fw-300 text-body text-justify limit-line-2 mb-0'>
                              {' '}
                              {item.desc}
                            </span>
                          </a>
                        </li>
                      ))}
                  {isMobile == 0 &&
                    _.filter(
                      list,
                      (item) => item.category_id === categoryInfo.id
                    )
                      .slice(0, 2)
                      .map((item) => (
                        <li>
                          <a
                            alt={`${item.category_name}-${item.name}`}
                            role='button'
                            href={this.getNewsLink(item)}
                            onClick={(e) => {
                              if (this.getNewsLink(item) === '#') {
                                e.preventDefault()
                              }
                            }}>
                            <div class='d-flex justify-content-between align-items-center text-navy mb-3'>
                              <h5 class='p fw-700 limit-line-1 text-highlight mb-0 mr-2'>
                                {item.name}
                              </h5>
                              <span class='p text-nowrap mb-0 ml-auto'>
                                {item.start_date &&
                                  moment(item.start_date).format('YYYY-MM-DD')}
                              </span>
                            </div>
                            <span class='note fw-300 text-body text-justify limit-line-2 mb-0'>
                              {' '}
                              {item.desc}
                            </span>
                          </a>
                        </li>
                      ))}
                </ul>
              </div>
            </div>
          ))}
        </Fragment>
      )
    }
    if (mode === NewsMode.Table) {
      return (
        <div class='container'>
          {_.map(_.get(listInfo, 'rows'), (item, idx) => (
            <Fragment>
              {item.category_id == 45 && idx == 0 && (
                <div class='px-4 p-3 px-md-5 bg-primary d-none d-lg-block' style={{ backgroundColor: '#2B61AF' }}>
                  <div class='row align-items-center p-1'>
                    <div class='col-lg-2'>
                      <h6 class='h5 text-white mb-0'>
                        {__('公佈日期', 'cec-plugin-stores')}
                      </h6>
                    </div>
                    <div class='col-lg'>
                      <h6 class='h5 text-white mb-0'>
                        {__('活動名稱', 'cec-plugin-stores')}
                      </h6>
                    </div>
                  </div>
                </div>
              )}
              <hr class='border-top border-primary m-0' />
              <a
                class='px-4 p-3 px-md-5 bg-white d-block text-decoration-none flex-list'
                role='button'
                href={this.getNewsLink(item)}
                onClick={(e) => {
                  if (this.getNewsLink(item) === '#') {
                    e.preventDefault()
                  }
                }}>
                {item.category_id == 45 && (
                  <div class='row align-items-center p-1'>
                    <div class='col-lg-2'>
                      <h6 class='h6 text-navy mb-0' data-title='公佈日期'>
                        {item.show_at.substring(0, 10)}
                      </h6>
                    </div>
                    <div class='col-lg'>
                      <h6 class='h6 text-navy mb-0' data-title='活動名稱'>
                        {item.name}
                      </h6>
                    </div>
                  </div>
                )}
                {item.category_id != 45 && (
                  <div class='row align-items-center'>
                    <div class='col-md-3'>
                      <h6 class='h5 text-navy mb-0'>{item.name}</h6>
                    </div>
                    <div class='col-auto'>
                      <h6 class='h5 text-navy mb-0'>
                        {item.start_date} - {item.end_date}
                      </h6>
                    </div>
                    <div class='col-auto ml-auto mt-md-0 mt-4'>
                      <p class='h6 text-primary mb-0'>
                        {item.start_date}
                        <span class='ml-2'>
                          {__('發佈', 'cec-plugin-stores')}
                        </span>
                      </p>
                    </div>
                  </div>
                )}
              </a>
            </Fragment>
          ))}
          <hr class='border-top border-primary m-0' />

          <Pagination
            current={_.get(listInfo, 'current', 0)}
            pageSize={_.get(listInfo, 'page_size', 10)}
            total={_.get(listInfo, 'total', 0)}
            onChange={(page, pageSize) => {
              this.loadData({ page, pageSize })
            }}
          />
        </div>
      )
    }
    if (mode === NewsMode.Grid) {
      return (
        <div class='container'>
          <div class='row no-gutters mx-n3'>
            {_.map(_.get(listInfo, 'rows'), (item) => (
              <Fragment>
                <div class='col-lg-6 px-3 my-3'>
                  <a
                    class='card card-event'
                    role='button'
                    href={this.getNewsLink(item)}
                    onClick={(e) => {
                      if (this.getNewsLink(item) === '#') {
                        e.preventDefault()
                      }
                    }}>
                    <div
                      class='img-2-1 card-img-top bg-contain'
                      style={{
                        backgroundImage: `url(${_.get(item, 'images.0.url')})`,
                      }}
                    />
                    <div class='card-body'>
                      <div class='d-flex justify-content-between align-items-center mb-3'>
                        <h5 class='h5 text-navy limit-line-1 mb-0'>
                          {item.name}
                        </h5>
                        <span class='note text-dark mb-0 text-nowrap'>
                          {item.start_date}-{item.end_date}
                        </span>
                      </div>
                      <p class='p text-dark limit-line-1 mb-0'>{item.desc}</p>
                    </div>
                  </a>
                </div>
              </Fragment>
            ))}
          </div>
          <Pagination
            current={_.get(listInfo, 'current', 0)}
            pageSize={_.get(listInfo, 'page_size', 10)}
            total={_.get(listInfo, 'total', 0)}
            onChange={(page, pageSize) => {
              this.loadData({ page, pageSize })
            }}
          />
        </div>
      )
    }
    if (mode === NewsMode.Grid2) {
      const rows = _.get(listInfo, 'rows', [])
      return (
        <Fragment>
          <div class='event-card-scroll_mobile mb-md-0 mb-5 swiper-container'>
            <div class='row no-gutters mx-n3 w-auto swiper-wrapper'>
              {_.map(rows, (item, idx) => {
                return (
                  <div
                    key={idx}
                    class='col-auto col-md-12 px-3 mb-4 swiper-slide'>
                    <a
                      class='card text-decoration-none border-0 shadow-0 p-0'
                      role='button'
                      href={this.getNewsLink(item)}
                      onClick={(e) => {
                        if (this.getNewsLink(item) === '#') {
                          e.preventDefault()
                        }
                      }}>
                      <div
                        class='img-2-1'
                        style={{
                          backgroundImage: `url(${_.get(
                            item,
                            'images.0.url',
                          )})`,
                        }}
                      />
                      <div class='card-body p-3'>
                        <h5 class='text-navy limit-line-1 mb-2 h6'>
                          {item.name}
                        </h5>
                        {/* <p class="note text-dark mb-0">目前在台灣已超過百家店，並具有多元發展的店家型態。</p> */}
                      </div>
                    </a>
                  </div>
                )
              })}
            </div>
            <div class='swiper-pagination' />
          </div>
        </Fragment>
      )

      // 4個以下滿版
      // 5個以上第一個滿版，之後對分
      // return (
      //   <Fragment>
      //     <h1>舊的上線確認後就可移除</h1>
      //     <div class='col-lg'>
      //       <div class='event-card-scroll_mobile mb-md-0 mb-5'>
      //         <div class='row no-gutters mx-n3'>
      //           {_.map(rows, (item, idx) => {
      //             let col =
      //               idx === 0 || rows.length <= 4 ? 'col-md-12' : 'col-md-6';

      //             return (
      //               <Fragment>
      //                 <div className={classnames(col, ' col-auto px-3 mb-4')}>
      //                   <a
      //                     class='card text-decoration-none border-0 shadow-0 p-0'
      //                     role='button'
      //                     href={this.getNewsLink(item)}
      //                   >
      //                     <div
      //                       class='img-2-1'
      //                       style={{
      //                         backgroundImage: `url(${_.get(
      //                           item,
      //                           'images.0.url'
      //                         )})`,
      //                       }}
      //                     />
      //                     <div class='card-body p-3'>
      //                       <h5 class='text-navy limit-line-1 mb-2 p'>
      //                         {item.name}
      //                       </h5>
      //                       {/* <span class="date">{item.start_date}-{item.end_date}</span> */}
      //                       {/* <p class="card-text">{item.desc}</p> */}
      //                     </div>
      //                   </a>
      //                 </div>
      //               </Fragment>
      //             );
      //           })}
      //         </div>
      //       </div>
      //     </div>
      //     <h1>新的整合中</h1>
      //     <div class='event-card-scroll_mobile mb-md-0 mb-5 swiper-container'>
      //       <div class='row no-gutters mx-n3 w-auto swiper-wrapper'>
      //         {_.map(rows, (item, idx) => (
      //           <div class='col-auto col-md-12 px-3 mb-4 swiper-slide'>
      //             <a
      //               class='card text-decoration-none border-0 shadow-0 p-0'
      //               role='button'
      //               href={this.getNewsLink(item)}
      //             >
      //               <div
      //                 class='img-2-1'
      //                 style={{
      //                   backgroundImage: `url(${_.get(item, 'images.0.url')})`,
      //                 }}
      //               />
      //               <div class='card-body p-3'>
      //                 <h5 class='text-navy limit-line-1 mb-2 h6'>
      //                   {item.name}
      //                 </h5>
      //                 {/* <p class="note text-dark mb-0">目前在台灣已超過百家店，並具有多元發展的店家型態。</p> */}
      //               </div>
      //             </a>
      //           </div>
      //         ))}
      //       </div>
      //       <div class='swiper-pagination' />
      //     </div>
      //   </Fragment>
      // );
    }
    if (mode === NewsMode.News) {
      const rows = _.get(listInfo, 'rows', [])
      const Local = _.get(window, 'VC_CONFIG.Locale')
      return (
        <main class='bg-light'>
          <div class='container'>
            <div class='breadcrumb-wrap py-4 m-0'>
              <nav aria-label='breadcrumb'>
                <ol class='breadcrumb'>
                  <li class='breadcrumb-item'>
                    <a
                      href={`${window.VC_CONFIG.INDEX_URL}${
                        Local == 'en_US' ? '/en' : ''
                      }`}>
                      {__('首頁', 'cec-plugin-stores')}
                    </a>
                  </li>
                  <li class='breadcrumb-item'>
                    <a
                      // href='javascript:void(0)'
                      onClick={(e) => e.preventDefault()}>
                      {__('最新消息', 'cec-plugin-stores')}
                    </a>
                  </li>
                  {this.state.cname && (
                    <li class='breadcrumb-item active' aria-current='page'>
                      {__(`${this.state.cname}`, 'cec-plugin-stores')}
                    </li>
                  )}
                </ol>
              </nav>
            </div>
          </div>
          <div class='banner banner-news'>
            <div class='container'>
              <div class='banner-image'>
                <img
                  src={`${
                    window.VC_CONFIG.PLUGIN_ASSETS_URL
                  }img/banner/news/event.svg`}
                  alt=''
                />
                {this.state.cname && <h3 class='title'>{this.state.cname}</h3>}
              </div>
            </div>
          </div>
          <div class='mb-5 basic-tabs-label'>
            <ul class='nav nav-pills' id='pills-tab'>
              <li
                class={
                  this.state.cname && this.state.cname == '注目活動'
                    ? 'nav-item current_page_item highlight'
                    : 'nav-item'
                }>
                <a class='nav-link' href={`${news_url}/?mode=6&cname=注目活動`}>
                  {__('注目活動', 'cec-plugin-stores')}
                </a>
              </li>
              <li
                class={
                  this.state.cname && this.state.cname == '會員活動'
                    ? 'nav-item current_page_item highlight'
                    : 'nav-item'
                }>
                <a class='nav-link' href={`${news_url}/?mode=6&cname=會員活動`}>
                  {__('會員活動', 'cec-plugin-stores')}
                </a>
              </li>
              <li
                class={
                  this.state.cname && this.state.cname == 'uniopen聯名卡活動'
                    ? 'nav-item current_page_item highlight'
                    : 'nav-item'
                }>
                <a
                  class='nav-link'
                  href={`${news_url}/?mode=6&cname=uniopen聯名卡活動`}>
                  {__('uniopen聯名卡活動', 'cec-plugin-stores')}
                </a>
              </li>

              <li
                class={
                  this.state.cname && this.state.cname == '新聞中心'
                    ? 'nav-item current_page_item highlight'
                    : 'nav-item'
                }>
                <a class='nav-link' href={`${news_url}/?mode=4&cname=新聞中心`}>
                  {__('新聞中心', 'cec-plugin-stores')}
                </a>
              </li>
              <li
                class={
                  this.state.cname && this.state.cname == '公告訊息'
                    ? 'nav-item current_page_item highlight'
                    : 'nav-item'
                }>
                <a class='nav-link' href={`${news_url}/?mode=4&cname=公告訊息`}>
                  {__('公告訊息', 'cec-plugin-stores')}
                </a>
              </li>
              <li
                class={
                  this.state.cname && this.state.cname == '得獎公告'
                    ? 'nav-item current_page_item highlight'
                    : 'nav-item'
                }>
                <a class='nav-link' href={`${news_url}/?mode=5&cname=得獎公告`}>
                  {__('得獎公告', 'cec-plugin-stores')}
                </a>
              </li>
            </ul>
          </div>
          {this.state.mode == 6 && (
            <div class='container'>
              <div class='row no-gutters mx-n3'>
                {_.map(_.get(listInfo, 'rows'), (item) => (
                  <Fragment>
                    <div class='col-lg-6 px-3 my-3'>
                      <a
                        class='card card-event'
                        role='button'
                        href={this.getNewsLink(item)}
                        target={item.action_type == 2 ? '_blank' : '_self'}
                        onClick={(e) => {
                          if (this.getNewsLink(item) === '#') {
                            e.preventDefault()
                          }
                        }}>
                        <div
                          class='img-2-1 card-img-top bg-contain'
                          style={
                            _.get(item, 'images.0.url')
                              ? {
                                  backgroundImage: `url(${_.get(
                                    item,
                                    'images.0.url'
                                  )})`,
                                }
                              : {
                                  backgroundImage: `url(${
                                    window.VC_CONFIG.PLUGIN_ASSETS_URL
                                  }img/news/logo_empty.jpg)`,
                                }
                          }
                        />
                        <div
                          class='card-body'
                          style={{ padding: ' 1rem 2rem' }}>
                          <div class='d-flex justify-content-between align-items-center mb-3'>
                            <h5 class='h5 text-navy limit-line-1 mb-0'>
                              {item.name}
                            </h5>
                            <span class='note text-dark mb-0 text-nowrap'>
                              {item.start_date}-{item.end_date}
                            </span>
                          </div>
                          <p class='h6 text-font limit-line-2 mb-0'>
                            {item.desc}
                          </p>
                        </div>
                      </a>
                    </div>
                  </Fragment>
                ))}
              </div>
              <Pagination
                current={_.get(listInfo, 'current', 0)}
                pageSize={_.get(listInfo, 'page_size', 10)}
                total={_.get(listInfo, 'total', 0)}
                onChange={(page, pageSize) => {
                  this.loadData({ page, pageSize })
                  window.scrollTo(0, 0)
                }}
              />
            </div>
          )}
          {(this.state.mode == 5 || this.state.mode == 4) && (
            <div class='container'>
              <div class='px-4 p-3 px-md-5 bg-primary d-none d-lg-block' style={{ backgroundColor: '#2B61AF' }}>
                <div class='row align-items-center p-1'>
                  <div class='col-lg-2'>
                    <h6 class='h5 text-white mb-0'>
                      {__('公佈日期', 'cec-plugin-stores')}
                    </h6>
                  </div>
                  <div class='col-lg'>
                    <h6 class='h5 text-white mb-0'>
                      {this.state.mode == 5
                        ? __('活動名稱', 'cec-plugin-stores')
                        : __('消息名稱', 'cec-plugin-stores')}
                    </h6>
                  </div>
                </div>
              </div>
              {_.map(_.get(listInfo, 'rows'), (item, idx) => (
                <Fragment>
                  <div>
                    <hr class='border-top border-primary m-0' />
                    <a
                      class='px-4 p-3 px-md-5 bg-white d-block text-decoration-none flex-list'
                      role='button'
                      href={this.getNewsLink(item)}
                      onClick={(e) => {
                        if (this.getNewsLink(item) === '#') {
                          e.preventDefault()
                        }
                      }}>
                      <div class='row align-items-center p-1'>
                        <div class='col-lg-2'>
                          <h6 class='h6 text-navy mb-0' data-title='公佈日期'>
                            {item.show_at.substring(0, 10)}
                          </h6>
                        </div>
                        <div class='col-lg'>
                          <h6 class='h6 text-navy mb-0' data-title='活動名稱'>
                            {item.name}
                          </h6>
                        </div>
                      </div>
                    </a>
                  </div>
                </Fragment>
              ))}
              <hr class='border-top border-primary m-0' />
              <Pagination
                current={_.get(listInfo, 'current', 0)}
                pageSize={_.get(listInfo, 'page_size', 10)}
                total={_.get(listInfo, 'total', 0)}
                onChange={(page, pageSize) => {
                  this.loadData({ page, pageSize })
                  window.scrollTo(0, 0)
                }}
              />
            </div>
          )}
        </main>
      )
    }

    return <Fragment />
  }
}

// 編輯器
const listGrid = { gutter: 16, xs: 1, sm: 2, md: 4, lg: 4, xl: 4, xxl: 4 }
export class NewsListPreviewEditor extends Component {
  formRef = React.createRef()
  state = {
    listInfo: _.cloneDeep(defaultListInfo),
  }
  componentDidMount() {
    AppHelper.updateConfig()

    this.formRef.current.setFieldsValue(this.props.attributes)
  }
  render() {
    const listInfo = this.state.listInfo
    const options = _.get(this, 'props.app.options', {})
    console.log('editor', this.props)

    return (
      <div className='vu-blocks-editor'>
        <div class='components-placeholder__label'>
          <span class='block-editor-block-icon'>
            <div class='dashicons dashicons-megaphone' />
          </span>
          消息列表
        </div>
        <Form
          ref={this.formRef}
          name='basic'
          className='basicForm'
          layout='vertical'
          // onFinish={values => this.submitData(values)}
          onValuesChange={(changedFields, allFields) =>
            this.props.setAttributes(changedFields)
          }>
          <Form.Item {...genFormItemAtrribute('mode', '顯示方式')}>
            <Select>
              <Select.Option value={NewsMode.Banner}>
                首頁大版位Banner
              </Select.Option>
              <Select.Option value={NewsMode.Carousel}>
                首頁中版位Banner
              </Select.Option>
              <Select.Option value={NewsMode.List}>首頁圖文列表</Select.Option>
              <Select.Option value={NewsMode.TextOnlyList}>
                首頁純文字列表
              </Select.Option>
              <Select.Option value={NewsMode.Table}>
                文字清單含分頁
              </Select.Option>
              <Select.Option value={NewsMode.Grid}>圖文清單</Select.Option>
              <Select.Option value={NewsMode.ByQuery}>
                依據URL Query呈現
              </Select.Option>
            </Select>
          </Form.Item>
          {this.formRef.current &&
            this.formRef.current.getFieldValue('mode') !== NewsMode.ByQuery && (
              <Form.Item {...genFormItemAtrribute('category_ids', '顯示類別')}>
                <Checkbox.Group>
                  <List
                    grid={listGrid}
                    dataSource={_.get(options, 'news_categories', [])}
                    renderItem={(item) => (
                      <List.Item>
                        <Checkbox value={item.id}>{item.name}</Checkbox>
                      </List.Item>
                    )}
                  />
                </Checkbox.Group>
              </Form.Item>
            )}
        </Form>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/blocks/news/news-list-preview.js